let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gZaei")).then(() => parcelRequire('73cSD'));